// extracted by mini-css-extract-plugin
module.exports = {"container":"NewsCard-module--container--3Zy6U","title":"NewsCard-module--title--3CgOF","category":"NewsCard-module--category--1-zPb","date":"NewsCard-module--date--UxRsJ"};